import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./HeaderBar.css";
import LeftArrowIcon from "../../images/icons/left_arrow.png";
import RightArrowIcon from "../../images/icons/right_arrow.png";
import NotiBell from "../../images/icons/noti.png";
import DefaultProfileImage from "../../images/DefaultProfileImage.png";
import Dropdown from "react-bootstrap/Dropdown";
import NotiProfileIcon from "../../images/icons/noti_profile.png";
import NotificationListItem from "../NotificationListItem/NotificationListItem";
import api from "../../api/api";
import getToken from "../../pages/getToken";
import apiUtil from "../../api/apiUtil";
import { Badge } from '@material-ui/core';


function HeaderBar(props) {
  const [isShowSideBar, setShowSideBar] = useState(true);
  const [user, setUser] = useState({});
  const [unseenCount, setUnSeenCount] = useState(0);
  const [notiList, setNotiList] = useState({
    isLoading: false,
    data: [],
  });

  let brandId = localStorage.getItem("brandId");
  let orgLevel;

  const getAdminInfo = () => {
    const userData = JSON.parse(localStorage.getItem("user"));

    const param = {
      userId: userData.userId,
      brandId: brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            localStorage.removeItem("orgLevel");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setUser({
              userName: response.data.data.userName,
              email: response.data.data.email,
              image: response.data.data.image,
            });
            localStorage.setItem("orgLevel", response.data.data.orgLevel);
            orgLevel = localStorage.getItem("orgLevel");
            // console.log(orgLevel);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  const getNotificationList = () => {
    setNotiList({
      ...notiList,
      isLoading: true,
    });
    api
      .post(`Admin/GetNotiByAdmin?BrandId=${brandId}`, {}, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              const data = response.data.data ?? []
              setNotiList({
                isLoading: false,
                data,
              });
              const unseen = data.filter(n => n.status == "unseen").length;
              setUnSeenCount(unseen);
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            setNotiList({
              data: [],
              total: 0,
              page: 0,
              limit: 0,
              isLoading: false,
            });
          }
        );
      });
  };

  const onClickNoti = (notiId) => {
    api
      .get(`Admin/AdminSeenNotification?NotiId=${notiId}`, {}, getToken())
      .then(
        (result) =>
          apiUtil.parseResult(
            result,
            (response) => {
              console.log(response);
              if (response.data.code === 401) {
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.code === 200) {
                console.log(response.data);
                getNotificationList();
              } else {
                alert(response.data.message);
              }
            },
            (error) => {
              alert(error);
            }
          ),
        (error) => {
          console.log(error);
        }
      );
  };
  const btnLogOut = () => {
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  useEffect(() => {
    getAdminInfo();
    getNotificationList();
  }, []);

  return (
    <div className={isShowSideBar ? "MenuBar" : "MenuBar MenuBarIcon"}>
      <div className="menuList">
        <div
          className="Open"
          onClick={() => {
            setShowSideBar(!isShowSideBar);
            props.setShowSideBar(!isShowSideBar);
          }}
        >
          <img
            src={isShowSideBar ? LeftArrowIcon : RightArrowIcon}
            alt=""
            className="arrowIcon"
          />
        </div>
        <div className="RightIcons">
          <Dropdown
            id="dropdown-button-drop-down"
            className="ddlNotification"
            autoClose="outside"
          >
            <Dropdown.Toggle>
              <Badge badgeContent={unseenCount} max={999} overlap="rectangular" color="error">
                <img
                  src={NotiBell}
                  alt="notiBell"
                  className="notiBell"
                  onClick={getNotificationList}
                />
              </Badge>
            </Dropdown.Toggle>
            <Dropdown.Menu >
              {notiList.data.map((item) => (
                <NotificationListItem
                  key={item.id}
                  onClick={() => onClickNoti(item.id)}
                  redirectTo={item.type}
                  senderImage={item.image ? item.image : NotiProfileIcon}
                  title={item.title}
                  desc={item.desc}
                  status={item.status}
                  date={item.notiDate}
                />
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown
            id="dropdown-button-drop-down"
            className="ddlAccount"
            autoClose="outside"
          >
            <Dropdown.Toggle>
              <img
                src={user.image ? user.image : DefaultProfileImage}
                alt="profileIcon"
                className={`profileIcon rounded-circle ${user.image == null && "empty_image"
                  }`}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Header>
                <h6>{user.userName ? user.userName : ""}</h6>
                <p>{user.userName ? user.email : ""}</p>
              </Dropdown.Header>
              <Dropdown.Divider />
              <Dropdown.Item as={Link} to="/profile-settings">Setting</Dropdown.Item>
              <Dropdown.Item as={Link} to="/account">Account</Dropdown.Item>
              <Dropdown.Item as={Link} to="/privacy-policy">
                Privacy Policy
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={btnLogOut}>Sign Out</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default HeaderBar;
